export const addLinkToText = text => {
  if (!text) {
    return '';
  }

  // Protect entire manual <a> tags - replace with placeholder so URL replacement won't touch them
  const protectedLinks = [];
  text = text.replace(/<a\s+href=["']((https?|ftp):\/\/[^"']+)["'][^>]*>([\s\S]*?)<\/a>/gi, (match, url, protocol, linkText) => {
    const key = `__MANUAL_LINK_${protectedLinks.length}__`;
    protectedLinks.push({ url, linkText });
    return key;
  });

  // Convert newlines to <br> so paragraphs render
  text = text.replace(/\n/g, '<br>');

  const httpsUrls = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
  const httpsLinkTemplate = '<a class="short-description__link" href=$1 target="_blank" rel="noopener noreferrer">$1</a>';
  text = text.replace(httpsUrls, httpsLinkTemplate);

  const wwwUrls = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  const wwwLinkTemplate = '$1<a class="short-description__link" href="http://$2" target="_blank" rel="noopener noreferrer">$2</a>';
  text = text.replace(wwwUrls, wwwLinkTemplate);

  // Restore manual links with proper styling and attributes
  protectedLinks.forEach(({ url, linkText }, i) => {
    const restoredLink = `<a class="short-description__link" href="${url}" target="_blank" rel="noopener noreferrer">${linkText}</a>`;
    text = text.replace(`__MANUAL_LINK_${i}__`, restoredLink);
  });

  return text;
};
